import FButton from "@components/FButton";
import { Permission, Role } from "@constants/roles";
import useAuth from "@hooks/useAuth";
import { useState } from "react";
import ShareLinkModal from "./ShareLinkModal";

interface ShareLinkButtonProps {
  name: string;
}

const ShareLinkButton = ({ name }: ShareLinkButtonProps) => {
  const { can, hasRole } = useAuth();

  const [isShareLinkModalVisible, setShareLinkModalVisible] = useState(false);

  return (
    <>
      {can(Permission.CREATE_SHARED_LINKS) && !hasRole(Role.OPEN_LINK) ? (
        <FButton
          className="ml-2"
          onClick={() => setShareLinkModalVisible(true)}
          label="Share"
          primary
          type="submit"
        />
      ) : null}
      {isShareLinkModalVisible ? (
        <ShareLinkModal
          name={name}
          onClose={() => setShareLinkModalVisible(false)}
        />
      ) : null}
    </>
  );
};

export default ShareLinkButton;
